export enum Error_Api {
	NO_ESTABLISHMENT = "NO_ESTABLISHMENT",
}